import { Link } from 'react-router-dom'

import { useStoredPrincipal } from '../hooks/useStoredPrincipal'
import { useT } from '../i18n'
import DailySheetImport from './importWorkspace/DailySheetImport'

// Findings #199: Configuración → Importaciones. Editors and admins back-fill
// older lots with the "Hoja diaria"; the older water import stays for admins.

export default function ImportRecords() {
  const t = useT()
  const principal = useStoredPrincipal()
  const canImport = !principal || principal.role === 'editor' || principal.role === 'admin'
  const isAdmin = !principal || principal.role === 'admin'

  return (
    <div style={{ padding: '24px 0 48px', display: 'grid', gap: 16, maxWidth: 1100 }}>
      <div>
        <h1 style={{ margin: '0 0 6px', fontSize: '1.6rem', color: '#0f172a' }}>{t('import.page.title')}</h1>
        <p style={{ margin: 0, color: '#475569', lineHeight: 1.6 }}>{t('import.page.subtitle')}</p>
      </div>
      <DailySheetImport canImport={canImport} />
      {isAdmin ? (
        <p style={{ margin: 0, fontSize: 13, color: '#64748b' }}>
          {t('import.page.waterHint')} <Link to="/imports/agua">{t('import.page.waterLink')}</Link>
        </p>
      ) : null}
    </div>
  )
}
